export function assert(condition) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Assertion failed';
  if (!condition) {
    throw new Error(message);
  }
}